export default "__VITE_ASSET__DKzQzT7U__"